export default __webpack_public_path__ + "static/media/service-5.32926603.png";